import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import api from "../api";
import { useAppContext } from "../context/AppContext";

export default function FavoriteButton({ propertyId, style = {} }) {
  const { user, lang, setToast } = useAppContext();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get(`/api/favorites/check/${propertyId}`)
      .then(r => setIsFavorite(r.isFavorite))
      .catch(() => {});
  }, [propertyId, user]);

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    if (!user) {
      setToast({ msg: lang === "en" ? "Please log in to save favorites" : "يرجى تسجيل الدخول لحفظ المفضلة", type: "info" });
      return;
    }

    setLoading(true);
    try {
      if (isFavorite) {
        await api.delete(`/api/favorites/${propertyId}`);
        setIsFavorite(false);
      } else {
        await api.post("/api/favorites", { projectId: propertyId });
        setIsFavorite(true);
        setToast({ msg: lang === "en" ? "Saved to favorites" : "تمت الإضافة للمفضلة", type: "success" });
      }
    } catch {
      setToast({ msg: lang === "en" ? "Failed to update favorites." : "فشل تحديث المفضلة.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      title={lang === "en" ? (isFavorite ? "Remove from favorites" : "Save to favorites") : (isFavorite ? "إزالة من المفضلة" : "حفظ في المفضلة")}
      style={{
        position: "absolute",
        top: 12,
        right: 12,
        width: 36,
        height: 36,
        borderRadius: "50%",
        background: isFavorite ? "rgba(239,68,68,.92)" : "rgba(255,255,255,0.92)",
        border: isFavorite ? "2px solid #ef4444" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.25s",
        boxShadow: "0 2px 8px rgba(0,0,0,.18)",
        ...style,
      }}
      onMouseEnter={(e) => { if (!loading) e.currentTarget.style.transform = "scale(1.12)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      <Heart
        size={16}
        fill={isFavorite ? "#fff" : "none"}
        stroke={isFavorite ? "#fff" : "#444"}
        style={{ transition: "all 0.25s" }}
      />
    </button>
  );
}
